/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-nested-ternary */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Box } from '@mui/material';

import { AiFillCheckCircle } from 'react-icons/ai';
import { IoArrowForwardCircle } from 'react-icons/io5';
import { toast } from 'react-toastify';

import { useLazyQuery, useQuery, NetworkStatus } from '@apollo/client';
import SwitchCustom from '../../../../../Switch/SwitchCustom';

import * as Q from '../../../../../../constants/graphqlQueries';

import './DimensionRC.css';

import CustomTextField from '../../../../../components/Textfield/CustomTextField';
import CustomDropdown from '../../../../../components/Dropdown/CustomDropdown';
import CustomButtons from '../../../../../components/Button/CustomButtons';
import colors from '../../../../../../constants/colors';

const dropdownOptionsStyles = (status) => ({
  status,
  style: {
    height: '30px',
    width: '30px',
    color: status ? colors.grey : colors.blue,
    padding: '0.5rem',
  },
});
const stackTokens = { childrenGap: 10 };

const optionsSwitch = {
  agentAction: {
    leftTitle: 'When agent is',
    rightTitle: 'When agent is not',
  },
  statusAction: {
    leftTitle: 'During',
    rightTitle: 'Not during',
  }
}
const RuleCreationErrorMessages = {
  DuplicatedRuleName: 'A rule with the same name already exists. Please try again with a different name.'
};
const FieldIndex = {
  ruleName: 1, alarmType: 2, ACDStatus: 3, scheduleContainer: 4, scheduleSegment: 5
};
const AlarmType = {
  SIU: 'SIU'
};

const DimensionSchedule = ({
  handleDimensionData, dimensionPreview, handleBack, codeTypes, ruleToEdit
}) => {
  const [inputFieldDisabled, setInputFieldDisabled] = useState(0);

  const [isAgent, setIsAgent] = useState(true);
  const [containerDuring, setContainerDuring] = useState(true);
  const [segmentDuring, setSegmentDuring] = useState(true);
  const [ruleName, setRuleName] = useState('');
  const [ruleNameToEdit, setRuleNameToEdit] = useState(null);
  const [selectedAlarm, setSelectedAlarm] = useState();

  const [alarmDisabled, setAlarmDisabled] = useState(true);

  const [ACDOption, setACDOption] = useState({});
  const [selectedACD, setSelectedACD] = useState();
  const [containerOption, setContainerOption] = useState({});
  const [selectedContainer, setSelectedContainer] = useState();
  const [segmentOption, setSegmentOption] = useState({});
  const [selectedSegment, setSelectedSegment] = useState();

  const [alarmTypeOption, setAlarmTypeOption] = useState({});
  const [ACDStatusOption, setACDStatusOption] = useState({});
  const [scheduleContainer, setScheduleContainer] = useState({});
  const [scheduleSegment, setScheduleSegment] = useState({});
  const [isNextButtonDisabled, setIsNextButtonDisabled] = useState(true);
  const [userClickedBack, setUserClickedBack] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [loadingScreen, setLoadingScreen] = useState(false);

  const [getIsRuleNameDuplicated, 
    { data: dataIsRuleDuplicatedByName, networkStatus: ruleNameValidationNetworkStatus }
  ] = useLazyQuery(Q.VALIDATE_RULE_NAME, { notifyOnNetworkStatusChange: true });
  const { data: alarmType, loading: loadingAlarm, refetch: refetchAlarmType } = useQuery(Q.ALARM_TYPE);
  const { data: ACDStatus, refetch: refetchACDStatus } = useQuery(Q.ACD_STATE);
  const { data: scheduleType, loading: loadingSchedule, refetch: refetchScheduleType } = useQuery(Q.CODE__MAPPING__SCHEDULE);

  // Set Toggle status
  const handleIsAgent = (checked) => {
    setIsAgent(!checked);
  };
  const handleContainerDuring = (checked) => {
    setContainerDuring(!checked);
  };
  const handleSegmentDuring = (checked) => {
    setSegmentDuring(!checked);
  };
  const handleRuleName = (value) => {
    setRuleName(value);
  };
  const handleSelected = (item) => {
    setSelectedAlarm(item);
    setAlarmDisabled(false);
  };
  const handleACDOption = (item) => {
    if (selectedAlarm.ScheduleAlarmCode !== AlarmType.SIU) { setACDOption({ ...dropdownOptionsStyles(true) }) };
    setSelectedACD(item);
  };
  const handleContainerOption = (item) => {
    setContainerOption({ ...dropdownOptionsStyles(true) });
    setSelectedContainer(item);
  };
  const handleSegmentOption = (item) => {
    setSegmentOption({ ...dropdownOptionsStyles(true) });
    setSelectedSegment(item);
  };

  // eslint-disable-next-line consistent-return
  const handleCancel = (isRestart) => {
      setIsAgent(false);
      setContainerDuring(false);
      setSegmentDuring(false);
      setSelectedAlarm(null);
      setACDOption(dropdownOptionsStyles(false));
      setSelectedACD(null);
      setContainerOption(dropdownOptionsStyles(false));
      setSelectedContainer(null);
      setSegmentOption(dropdownOptionsStyles(false));
      setSelectedSegment(null);

      setIsNextButtonDisabled(true);
      setRuleName('');
      setRuleNameToEdit(null);
      setAlarmDisabled(true);
      if (isRestart) handleBack('Cancel');
  };
  const submitDimensionData = () => {
    const dimensionDataToCreate = [{
      ruleName,
      scheduleAlarmCode: selectedAlarm.ScheduleAlarmCode,
      externalKey: selectedAlarm.ScheduleAlarmExternalKey,
      agentStatus: isAgent ? 1 : 0,
      containerStatus: containerDuring ? 1 : 0,
      segmentStatus: segmentDuring ? 1 : 0,
      ACDOption: selectedACD.Label === 'Not Applicable' ? '' : selectedACD.Label,
      ACDCodeMappingId: selectedACD.ACDCodeMappingId,
      containerId: selectedContainer ? selectedContainer.CodeMappingId : '',
      container: selectedContainer ? selectedContainer.Label : '',
      segmentId: selectedSegment ? selectedSegment.CodeMappingId : '',
      segment: selectedSegment ? selectedSegment.Label : '',
    }];
    handleDimensionData(dimensionDataToCreate);
  }
  const validateRuleName = () => {
    setLoadingSubmit(true);
    getIsRuleNameDuplicated({
      variables: {
        RuleName: ruleName
      }
    });
  };
  const isInputFieldDisabled = (inputIndex) => {
    if (inputFieldDisabled && inputIndex > inputFieldDisabled) {
      return true;
    };
    return false;
  };

  useEffect(() => {
    setACDOption(dropdownOptionsStyles(false));
    setContainerOption(dropdownOptionsStyles(false));
    setSegmentOption(dropdownOptionsStyles(false));
  }, []);
  useEffect(() => {
    if (alarmType) {
      const alarmProps = {
        options: alarmType.scheduleAlarm,
        getOptionLabel: (option) => option.ScheduleAlarmCode
      }
      setAlarmTypeOption(alarmProps);
    }
  }, [alarmType]);
  useEffect(() => {
    if (dimensionPreview.length && !loadingAlarm) {
      setSelectedAlarm({
        ScheduleAlarmCode: dimensionPreview[0].scheduleAlarmCode,
        ScheduleAlarmExternalKey: dimensionPreview[0].externalKey,
      });
    }
  }, [loadingAlarm]);
  useEffect(() => {
    if (ACDStatus) {
      const ACDStateProps = [ { Label: 'Not Applicable', ACDCodeMappingId: null }, ...ACDStatus.getAllACDCodeMapping]
      const ACDStatusProps = {
        options: ACDStateProps,
        getOptionLabel: option => option.Label
      }
      setACDStatusOption(ACDStatusProps);
    }
  }, [ACDStatus]);
  useEffect(() => {
    if (scheduleType) {
      const containerProps = {
        options: scheduleType?.codeMappings.filter(
          (types) => types.ScheduleTypeId === 1),
        getOptionLabel: (option) => option.Label
      }
      const segmentProps = {
        options: scheduleType?.codeMappings.filter(
          (types) => types.ScheduleTypeId === 2),
        getOptionLabel: (option) => option.Label
      }
      setScheduleContainer(containerProps);
      setScheduleSegment(segmentProps);
    }
  }, [scheduleType]);
  useEffect(() => {
    if (dimensionPreview.length && !loadingSchedule) {
      setSelectedContainer({
        Label: dimensionPreview[0].container,
        CodeMappingId: dimensionPreview[0].containerId
      });
      setSelectedSegment({
        Label: dimensionPreview[0].segment,
        CodeMappingId: dimensionPreview[0].segmentId
      });
    }
  }, [loadingSchedule]);
  useEffect(() => {
    if (dimensionPreview.length) {
      if (!(Object.keys(ACDStatusOption).length)
        && !(Object.keys(scheduleContainer).length)
        && !(Object.keys(scheduleSegment).length)
        && !(Object.keys(alarmTypeOption).length)) {
          const fetchData = async () => {
          await refetchAlarmType();
          await refetchACDStatus();
          await refetchScheduleType();
          setUserClickedBack(true);
        }

        fetchData();
      }
      else if (dimensionPreview.length && ruleToEdit !== null) setIsEdit(true);
    }
  }, [dimensionPreview]);
  useEffect(() => {
    if ((dimensionPreview.length && userClickedBack &&
      Object.keys(ACDStatusOption).length
      && Object.keys(scheduleContainer).length
      && Object.keys(scheduleSegment).length
      && Object.keys(alarmTypeOption).length) || (isEdit && dimensionPreview.length)) {
      setIsAgent(Boolean((dimensionPreview[0].agentStatus)));
      setContainerDuring(Boolean((dimensionPreview[0].containerStatus)));
      setSegmentDuring(Boolean((dimensionPreview[0].segmentStatus)));
      setSelectedAlarm({
        ScheduleAlarmCode: dimensionPreview[0].scheduleAlarmCode,
        ScheduleAlarmExternalKey: dimensionPreview[0].externalKey,
      });
      setRuleName(dimensionPreview[0].ruleName);
      setRuleNameToEdit(dimensionPreview[0].ruleName);
      setSelectedACD({ Label: dimensionPreview[0].ACDOption === '' ? 'Not Applicable' : dimensionPreview[0].ACDOption, ACDCodeMappingId: dimensionPreview[0].ACDCodeMappingId, });
      setContainerOption({ ...dropdownOptionsStyles(true) });
      setSelectedContainer({
        Label: dimensionPreview[0].container,
        CodeMappingId: dimensionPreview[0].containerId
      });
      setSegmentOption({ ...dropdownOptionsStyles(true) });

      setSelectedSegment({
        Label: dimensionPreview[0].segment,
        CodeMappingId: dimensionPreview[0].segmentId
      });
      if (dimensionPreview[0].scheduleAlarmCode === 'SIU') {
        setInputFieldDisabled(FieldIndex.ACDStatus);
      } else {
        setInputFieldDisabled(FieldIndex.scheduleSegment);
      }
      setACDOption({ ...dropdownOptionsStyles(true) });
      setAlarmDisabled(false);
      setIsNextButtonDisabled(false);
      setLoadingScreen(false);
    }
  }, [userClickedBack, isEdit]);
  useEffect(() => {
    if (selectedAlarm) {
      if (selectedAlarm.ScheduleAlarmCode === AlarmType.SIU) {
        setSelectedContainer(null);
        setSelectedSegment(null);
      }
    }
  }, [selectedAlarm]);
  useEffect(() => {
    if (!ruleName && !codeTypes || !selectedAlarm) {
      if (!ruleName && !codeTypes) setInputFieldDisabled(FieldIndex.ruleName);
      else setInputFieldDisabled(FieldIndex.alarmType);
    }
    else if (!selectedACD) setInputFieldDisabled(FieldIndex.ACDStatus);
    else if (!selectedContainer && selectedAlarm.ScheduleAlarmCode !== AlarmType.SIU) setInputFieldDisabled(FieldIndex.scheduleContainer);
    else if (!selectedSegment && selectedAlarm.ScheduleAlarmCode !== AlarmType.SIU) {
      setInputFieldDisabled(FieldIndex.scheduleSegment)
    } else {
      setInputFieldDisabled(null);
    }
  }, [codeTypes, ruleName, selectedAlarm, selectedACD, selectedContainer, selectedSegment]);
  useEffect(() => {
    if (inputFieldDisabled === null) setIsNextButtonDisabled(false);
    else setIsNextButtonDisabled(true);
  }, [inputFieldDisabled]);
  useEffect(() => {
    if (ruleNameValidationNetworkStatus === NetworkStatus.ready && dataIsRuleDuplicatedByName) {
      if (!(dataIsRuleDuplicatedByName.isRuleDuplicatedByName) || ruleName === ruleNameToEdit) {
        submitDimensionData();
      }
      else {
        toast(RuleCreationErrorMessages.DuplicatedRuleName);
      }
      setLoadingSubmit(false);
    }
  }, [ruleNameValidationNetworkStatus]);
  useEffect(() => {
    if (codeTypes) handleCancel();
  }, [codeTypes]);
  useEffect(() => {
    if (ruleToEdit) setLoadingScreen(true);
  }, [ruleToEdit]);

  return (
    <Box className='dimension__box' tokens={stackTokens}>
      <div className='dimension__row'>
        {!codeTypes && (
          <Box className='dimension__row__wrapper'>
            <CustomTextField
              title='Rule Name'
              value={ruleName}
              handleChange={handleRuleName}
              placeholder='Input text'
              mandatory
              loading={loadingScreen}
              maxLength={25}
            />
          </Box>
        )}
        <div className='dimension__row__wrapper'>
          <CustomDropdown
            title='Alarm Type'
            value={selectedAlarm}
            handleChange={handleSelected}
            defaultProps={alarmTypeOption}
            disabled={isInputFieldDisabled(FieldIndex.alarmType)}
            mandatory
            loading={loadingScreen}
          />
        </div>
      </div>
      <div className='dimension__wrapper'>
        <div className='dimension__wrapper__box'>
          <div className='dimension__wrapper__toggle'>
            {!alarmDisabled ? (!ACDOption.status
              ? <IoArrowForwardCircle style={ACDOption.style} />
              : <AiFillCheckCircle style={ACDOption.style} />) : ''}
            <SwitchCustom
              // Workaround: reverse the display option to preserve real boolean value
              switchStatus={!isAgent}
              options={optionsSwitch.agentAction}
              handleSwitch={handleIsAgent}
              disabledStatus={alarmDisabled}
              isDualOption
              loading={loadingScreen}
              />
          </div>
          <div className='dimension__wrapper__toggle'>
            {ACDOption.status ? (!containerOption.status
              ? <IoArrowForwardCircle style={containerOption.style} />
              : <AiFillCheckCircle style={containerOption.style} />) : ''}
            <SwitchCustom
              // Workaround: reverse the display option to preserve real boolean value
              switchStatus={!containerDuring}
              options={optionsSwitch.statusAction}
              handleSwitch={handleContainerDuring}
              disabledStatus={!ACDOption.status}
              isDualOption
              loading={loadingScreen}
            />
          </div>
          <div className='dimension__wrapper__toggle'>
            {containerOption.status ? (!segmentOption.status
              ? <IoArrowForwardCircle style={segmentOption.style} />
              : <AiFillCheckCircle style={segmentOption.style} />) : ''}
            <SwitchCustom
              // Workaround: reverse the display option to preserve real boolean value
              switchStatus={!segmentDuring}
              options={optionsSwitch.statusAction}
              handleSwitch={handleSegmentDuring}
              disabledStatus={!containerOption.status}
              isDualOption
              loading={loadingScreen}
            />
          </div>
        </div>
        <div className='dimension__wrapper__box'>
          <CustomDropdown
            title='ACD State'
            value={selectedACD}
            handleChange={handleACDOption}
            defaultProps={ACDStatusOption}
            disabled={isInputFieldDisabled(FieldIndex.ACDStatus)}
            mandatory
            loading={loadingScreen}
          />
          <CustomDropdown
            title='Schedule Container'
            value={selectedContainer}
            handleChange={handleContainerOption}
            defaultProps={scheduleContainer}
            disabled={selectedAlarm ? selectedAlarm.ScheduleAlarmCode === 'SIU' || isInputFieldDisabled(FieldIndex.scheduleContainer) : isInputFieldDisabled(FieldIndex.scheduleContainer)}
            mandatory
            loading={loadingScreen}
          />
          <CustomDropdown
            title='Schedule Segment'
            value={selectedSegment}
            handleChange={handleSegmentOption}
            defaultProps={scheduleSegment}
            disabled={selectedAlarm ? selectedAlarm.ScheduleAlarmCode === 'SIU' || isInputFieldDisabled(FieldIndex.scheduleSegment) : isInputFieldDisabled(FieldIndex.scheduleSegment)}
            mandatory
            loading={loadingScreen}
          />
        </div>
      </div>
      <div className='create__wrapper_btn'>
        <CustomButtons
          handleClick={() => handleCancel(true)}
          name='Cancel'
          loading={loadingScreen}
        />
        {codeTypes &&
          <CustomButtons
            handleClick={handleBack}
            name='Back'
          />
        }
        <CustomButtons
          handleClick={validateRuleName}
          name='Next'
          disabled={isNextButtonDisabled}
          tooltipFree
          loadingButton={loadingSubmit}
          loading={loadingScreen}
        />
      </div>
    </Box>
  );
};

DimensionSchedule.propTypes = {
  handleDimensionData: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  dimensionPreview: PropTypes.array.isRequired,
  handleBack: PropTypes.func.isRequired,
  codeTypes: PropTypes.bool.isRequired,
  ruleToEdit: PropTypes.number
};

DimensionSchedule.defaultProps = {
  ruleToEdit: null
};

export default DimensionSchedule;
